import * as i0 from "@angular/core";
export class ConsoleService {
    constructor() { }
    consoleLog(label, data) {
        //  console.log(label, data)
    }
}
ConsoleService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ConsoleService_Factory() { return new ConsoleService(); }, token: ConsoleService, providedIn: "root" });
